// extracted by mini-css-extract-plugin
module.exports = {"buttonContainer":"BalanceMinutes_buttonContainer__3zKeI","rightMarginButton":"BalanceMinutes_rightMarginButton__3StTH"};